import React from 'react'
import { Button } from 'react-bootstrap';
import ErrorsTable from './ErrorsTable';

const ModalBodyDifferenceErrors = ({
  companyErrors = [],
  previredErrors = [],
  siitaxErrors = [],
  acceptUpdate,
  cancelUpdate,
  payrollProcess
}) => {
  return (
    <div>
      <h5 className="text-uppercase">Existen diferencias en los siguientes campos:</h5>
      {
        companyErrors.length > 0 && (
          <div className="alert alert-danger mb-1">
            <h5 className="text-uppercase">Empresa</h5>
            <ErrorsTable errors={companyErrors} />
          </div>
        )
      }
      {
        previredErrors.length > 0 && (
          <div className="alert alert-danger mb-1">
            <h5 className="text-uppercase">Previred</h5>
            <ErrorsTable errors={previredErrors} />
          </div>
        )
      }
      {
        siitaxErrors.length > 0 && (
          <div className="alert alert-danger mb-1">
            <h5 className="text-uppercase">Servicios de Impuestos Internos</h5>
            <ErrorsTable errors={siitaxErrors} />
          </div>
        )
      }
      <p className="mx-3 font-weight-normal danger">
        Una vez reprocesado el proceso, esta acción no se puede deshacer.
      </p>
      <div className="modal-footer">
        <Button variant="outline-info" onClick={() => cancelUpdate(payrollProcess)}>
          Continuar sin procesar
        </Button>
        <Button variant="primary" onClick={() => acceptUpdate(payrollProcess)}>
          Reprocesar
        </Button>
      </div>
    </div>
  )
}

export default ModalBodyDifferenceErrors;